import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  selected?: boolean;
  value?: string;
}

export function SelectOption(props: Props) {
  return (
    <option selected={props.selected} value={props.value}>
      {props.children}
    </option>
  );
}
